module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/BANISHED_S01.dd584cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/BANISHED_S01.jpg
// module id = CWYT
// module chunks = 0